// extracted by mini-css-extract-plugin
export var appStore = "styles-module__appStore___TEaO8";
export var button = "styles-module__button___IOhVk";
export var close = "styles-module__close___pgHYe";
export var container = "styles-module__container___ppfKO";
export var content = "styles-module__content___Mrncu";
export var error = "styles-module__error___RKA67";
export var form = "styles-module__form___oIfiU";
export var gray = "styles-module__gray___peFst";
export var img = "styles-module__img___eWkQd";
export var input = "styles-module__input___OxqQo";
export var instructions = "styles-module__instructions___o_jp5";
export var instructionsNonEnglish = "styles-module__instructionsNonEnglish___HYzfR";
export var storeBadges = "styles-module__storeBadges___GI2kJ";
export var theFinePrint = "styles-module__theFinePrint___oE_Z3";
export var title = "styles-module__title___afUvd";
export var titleNonEnglish = "styles-module__titleNonEnglish___xaV67";
export var white = "styles-module__white___HhXCP";